import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { editarNota } from '../../actions/asesorias';

const EditarNota = ({ nota, reestablecerNota }) => {

    const dispatch =  useDispatch();

    const [notaData, setNotaData] = useState({
        id_nota: null, 
        id_asesoria: null, 
        contenido: null
    });

    const [notaModal, setNotaModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Agregar nota */
    const handleInputChange = ({ target }) => {
        setNotaData({
            ...notaData,
            [target.name]: target.value
        });
    }

    const handleProcesar = async () => {
        await setStatusProcesar(true);

        await dispatch(editarNota(notaData));

        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setNotaData({
                id_nota: null, 
                id_asesoria: null, 
                contenido: null
            });

            reestablecerNota(null);

            setNotaModal(false);
        }
    }

    useEffect(() => {
        if(nota){            
            setNotaData({
                ...notaData, 
                id_nota: nota.id_nota, 
                id_asesoria: nota.id_asesoria, 
                contenido: nota.contenido
            });

            setNotaModal(true);
        }
    }, [nota]);

    return (
        <Modal show={notaModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar nota</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <textarea className="form-control textareCampo" placeholder="Nota" id="contenido" name="contenido" value={notaData.contenido} onChange={e => handleInputChange(e)}></textarea>
                            <label htmlFor="contenido">Nota</label>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarNota;